var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{staticClass:"ga-tracking-sitewide-banner",attrs:{"native":false,"to":_vm.link,"target":_vm.hrefTarget}},[_c('nuxt-img',{attrs:{"loading":"lazy","src":_vm.imgSrc,"alt":"Sitewide Banner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }